import { Dropdown as TkDropdown } from "@constellation-academy/epic-ui";
import tw from "twin.macro";

export const Wrapper = tw.div`tw-flex tw-mb-12`;

export const Dropdown = tw(TkDropdown)`tw-mr-12`;
